import { useCurrentProject } from '../ProjectEntitlementsContext';

/**
 * Checks whether tool is available in current project.
 * If productId is provided, checks whether tool is available in the product and is authorized.
 * If productId is not provided, checks whether tool is available in any product and is authorized.
 * @param toolId - tool id
 * @param productId - product id
 * @returns {boolean}
 */
export function useToolAvailable({
  toolId,
  productId,
}: {
  toolId: string;
  productId?: string;
}) {
  const currentProject = useCurrentProject();

  if (productId) {
    const product = currentProject?.products.find(
      (p) => p.key === productId && p.authorized,
    );

    return Boolean(
      product?.tools?.some(
        (tool) => tool.key === toolId && tool.authorized !== false,
      ),
    );
  } else {
    return Boolean(
      currentProject?.products.some(
        (product) =>
          product?.authorized &&
          product?.tools?.some(
            (tool) => tool.key === toolId && tool.authorized !== false,
          ),
      ),
    );
  }
}
